export default "__VITE_ASSET__B38DN7SJ__"